import {
  IonIcon,
  IonItem,
  IonCard,
  IonText,
  IonLabel,
  IonGrid,
  IonList,
  IonRow,
  IonCol,
  IonFab,
} from "@ionic/react";
import { useState } from "react";
import {
  warningOutline,
  checkmarkDoneOutline,
  documentTextOutline,
  timeOutline,
  chevronUpOutline,
  chevronDownOutline,
  receiptOutline,
} from "ionicons/icons";
import { useSelector } from "react-redux";
import { selectUserDocuments } from "../../../store/userShow/selectors/selectuserDocuments";
import { userDocumentsFetchStatus } from "../../../store/userShow/selectors/userDocumentFetchStatus";
import { UserDocumentsList } from "./UserDocumentsList";
import { UploadButton } from "./UploadButton";
import { DocumentUploadTooltip } from "./DocumentUploadTolltip";

export const UserDocumentsFolder = ({ userId }: any) => {
  const userDocumentsList = useSelector(selectUserDocuments);
  const status = useSelector(userDocumentsFetchStatus);

  //Funciones para recordar y modificar estado de desplegables de cada categoria

  const [showCounters, setShowCounters] = useState(false);

  const counterDropdownMobile = () => {
    setShowCounters(!showCounters);
  };

  const categoryListState: boolean[] = [];
  const listStateFunction = () => {
    let listState = false;
    userDocumentsList?.map(() => {
      listState = false;
      categoryListState.push(listState);
    });
  };
  const [lista, setListState] = useState(categoryListState);
  const pasarIndex = (index: number) => {
    setListState((lista) => {
      const newState = [...lista];
      newState[index] = !newState[index];
      return newState;
    });
  };

  //Variables del contador
  let pending = 0;
  let pendingS = 0;
  let fexpire = 0;
  let expired = 0;
  let complianceRejected = 0;
  let compliancePending = 0;
  let ok = 0;

  //Funcion para el conteo
  const counterFunction = () => {
    userDocumentsList?.map((doc) => {
      const pendiente = doc.documents.length === 0;
      const expirationDays = doc.expirationDays;
      //Funcion map para contadores
      doc.documents.map((documents: any) => {
        //Conteo pendientes de firma
        //Condicion para documentos pendientes de firma
        const pendingSignature = documents.status?.id === 2;
        //Evauluacion de condicion y anotacion de documentos con condicion
        if (pendingSignature) {
          pendingS = pendingS + 1;
        }

        //Conteo vencidos y pendientes
        const toDate = documents.toDate;
        const date1: Date = new Date(toDate);
        const date2: Date = new Date();
        const timeInMilisec: number = date1.getTime() - date2.getTime();
        const daysBetweenDates: number = Math.ceil(timeInMilisec / (1000 * 60 * 60 * 24));
        //Condiciones para vencimiento
        const forExpire = daysBetweenDates > 0 && daysBetweenDates < expirationDays;
        const expiredDocument = toDate != null && daysBetweenDates < 0;
        //Evaluacion de condciones y anotacion de documentos con condiciones
        if (forExpire) {
          fexpire = fexpire + 1;
        }
        if (expiredDocument) {
          expired = expired + 1;
        }

        //Conteo devueltos por compliance y pendientes
        //Condiciones para status de compliance
        const complianceIsWaiting = documents.complianceStatus === "documento_subido";
        const complianceIsRejected = documents.complianceStatus === "devuelto";
        const complianceIsCreated = documents.complianceStatus === "creacion";
        //Evaluacion de condiciones y anotacion de documentos con condiciones
        if (complianceIsWaiting) {
          compliancePending = compliancePending + 1;
        }
        if (complianceIsCreated) {
          complianceRejected = complianceRejected + 1;
        }
        if (complianceIsRejected) {
          complianceRejected = complianceRejected + 1;
        }

        //Condicion y conteo de documento para que este en status OK
        if (
          pendingSignature === false &&
          forExpire === false &&
          expiredDocument === false &&
          complianceIsWaiting === false &&
          complianceIsRejected === false &&
          complianceIsCreated === false
        ) {
          ok = ok + 1;
        }
      });
      //Conteo de categorias pendientes (no traen documentos)
      if (pendiente) {
        pending = pending + 1;
      }
    });
  };

  //Funciones para conteo de tipos de documento dentro de cada categoria
  //Variables para almacenar el conteo de cada tipo de documento

  const signaturePending: number[] = [];
  const nextToExpire: number[] = [];
  const expiredDocuments: number[] = [];
  const compliancePendingStatus: number[] = [];
  const complianceRejectedStatus: number[] = [];
  const complianceWaitingStatus: number[] = [];
  const okStatus: number[] = [];

  //Logica para el conteo y asignacion de pendientes de firma
  const calculateSignaturePendingFunction = () => {
    let signaturePendingNumber = 0;
    userDocumentsList?.map((document) => {
      document.documents.map((pendingNumber: any) => {
        if (pendingNumber.status?.id === 2) {
          signaturePendingNumber = signaturePendingNumber + 1;
        }
      });
      signaturePending.push(signaturePendingNumber);
      signaturePendingNumber = 0;
    });
  };

  //Logica para conteo y asignacion de numero de docuementos proximos a vencer y vencidos
  const calculateNextToExpire = () => {
    let nextToExpireNumber = 0;
    let expiredNumber = 0;
    userDocumentsList?.map((document) => {
      const expirationDays = document.expirationDays;
      document.documents.map((expiration: any) => {
        const toDate = expiration.toDate;
        const date1: Date = new Date(toDate);
        const date2: Date = new Date();
        const timeInMilisec: number = date1.getTime() - date2.getTime();
        const daysBetweenDates: number = Math.ceil(timeInMilisec / (1000 * 60 * 60 * 24));
        if (daysBetweenDates > 0 && daysBetweenDates < expirationDays) {
          nextToExpireNumber = nextToExpireNumber + 1;
        }
        if (toDate != null && daysBetweenDates < 0) {
          expiredNumber = expiredNumber + 1;
        }
      });
      nextToExpire.push(nextToExpireNumber);
      nextToExpireNumber = 0;
      expiredDocuments.push(expiredNumber);
      expiredNumber = 0;
    });
  };

  //Funcion para el conteo y asignacion de numero de documentos devueltos y pendientes de compliance
  const calculateComplianceStatus = () => {
    let compliancePendingNumber = 0;
    let complianceRejectedNumber = 0;
    let complianceWaitingNumber = 0;
    userDocumentsList?.map((document) => {
      document.documents.map((compliance: any) => {
        if (compliance.complianceStatus === "documento_subido") {
          compliancePendingNumber = compliancePendingNumber + 1;
        }
        if (compliance.complianceStatus === "creacion") {
          complianceRejectedNumber = complianceRejectedNumber + 1;
          complianceWaitingNumber = complianceWaitingNumber + 1;
        }
        if (compliance.complianceStatus === "devuelto") {
          complianceRejectedNumber = complianceRejectedNumber + 1;
        }
      });
      compliancePendingStatus.push(compliancePendingNumber);
      compliancePendingNumber = 0;
      complianceRejectedStatus.push(complianceRejectedNumber);
      complianceRejectedNumber = 0;
      complianceWaitingStatus.push(complianceWaitingNumber);
      complianceWaitingNumber = 0;
    });
  };


  //Funcion para el conteo y asignacion de numero de documentos con estado OK
  const calculateOkStatus = () => {
    let okStatusNumber = 0;
    userDocumentsList?.map((doc) => {
      const expirationDays = doc.expirationDays;
      //Funcion map para contadores
      doc.documents.map((documents: any) => {
        const pendingSignature = documents.status?.id === 2;
        //Conteo vencidos y pendientes
        const toDate = documents.toDate;
        const date1: Date = new Date(toDate);
        const date2: Date = new Date();
        const timeInMilisec: number = date1.getTime() - date2.getTime();
        const daysBetweenDates: number = Math.ceil(timeInMilisec / (1000 * 60 * 60 * 24));
        const forExpire = daysBetweenDates > 0 && daysBetweenDates < expirationDays;
        const expiredDocument = toDate != null && daysBetweenDates < 0;
        const complianceIsWaiting = documents.complianceStatus === "documento_subido";
        const complianceIsRejected = documents.complianceStatus === "devuelto";
        const complianceIsCreated = documents.complianceStatus === "creacion";

        //Condicion y conteo de documento para que este en status OK
        if (
          pendingSignature === false &&
          forExpire === false &&
          expiredDocument === false &&
          complianceIsWaiting === false &&
          complianceIsRejected === false &&
          complianceIsCreated === false
        ) {
          okStatusNumber = okStatusNumber + 1;
        }
      });
      okStatus.push(okStatusNumber);
      okStatusNumber = 0;
    });
  };

  //Ejecucion de funciones para alimentar variables
  listStateFunction();
  counterFunction();
  calculateSignaturePendingFunction();
  calculateNextToExpire();
  calculateComplianceStatus();
  calculateOkStatus();

  return (
    <>
      <section className="ion-margin-top" style={{ maxWidth: 1000 }}>
        <h2 className="ion-padding-horizontal">
          <IonText color="primary" className="ion-color ion-color-primary md hydrated">
            Documentos
          </IonText>
        </h2>
        <IonCard>
          <IonItem
            lines="none"
            style={{ textAlign: "center", overflow: "visible" }}
            className="ion-hide-md-down"
          >
            <IonLabel className="sc-IonLabel-md-h sc-IonLabel-md-s md">
              <IonIcon
                icon={warningOutline}
                style={{ color: "red", fontSize: 20, marginBottom: 3 }}
              />
              <IonText style={{ verticalAlign: "super", margin: 5 }}>{pending}</IonText>
              <h3 className="ion-hide-md-down">Pendientes</h3>
            </IonLabel>
            <IonLabel className="sc-IonLabel-md-h sc-IonLabel-md-s md">
              <IonIcon
                icon={documentTextOutline}
                style={{ color: "red", fontSize: 20, marginBottom: 3 }}
              />
              <IonText style={{ verticalAlign: "super", margin: 5 }}>{pendingS}</IonText>
              <h3 className="ion-hide-md-down">
                Firmas <br /> pendientes
              </h3>
            </IonLabel>

            <IonLabel className="sc-IonLabel-md-h sc-IonLabel-md-s md">
              <IonIcon
                icon={timeOutline}
                color="warning"
                style={{ fontSize: 20, marginBottom: 3 }}
              />
              <IonText style={{ verticalAlign: "super", margin: 5 }}>{fexpire}</IonText>
              <h3 className="ion-hide-md-down">Por Vencer</h3>
            </IonLabel>

            <IonLabel className="sc-IonLabel-md-h sc-IonLabel-md-s md">
              <IonIcon icon={timeOutline} style={{ color: "red", fontSize: 20, marginBottom: 3 }} />
              <IonText style={{ verticalAlign: "super", margin: 5 }}>{expired}</IonText>
              <h3 className="ion-hide-md-down">Vencidos</h3>
            </IonLabel>

            <IonLabel className="sc-IonLabel-md-h sc-IonLabel-md-s md">
              <IonIcon
                icon={receiptOutline}
                style={{ color: "red", fontSize: 20, marginBottom: 3 }}
              />
              <IonText style={{ verticalAlign: "super", margin: 5 }}>{complianceRejected}</IonText>
              <h3 className="ion-hide-md-down">
                Pendientes <br /> Compliance
              </h3>
            </IonLabel>

            <IonLabel className="sc-IonLabel-md-h sc-IonLabel-md-s md">
              <IonIcon
                icon={receiptOutline}
                style={{ color: "blue", fontSize: 20, marginBottom: 3 }}
              />
              <IonText style={{ verticalAlign: "super", margin: 5 }}>{compliancePending}</IonText>
              <h3 className="ion-hide-md-down">
                Revisión <br /> Compliance
              </h3>
            </IonLabel>

            <IonLabel className="sc-IonLabel-md-h sc-IonLabel-md-s md">
              <IonIcon
                icon={checkmarkDoneOutline}
                color="success"
                style={{ fontSize: 20, marginBottom: 3 }}
              />
              <IonText style={{ verticalAlign: "super", margin: 5 }}>{ok}</IonText>
              <h3 className="ion-hide-md-down">Ok</h3>
            </IonLabel>
            <IonLabel className="ion-hide-md-up">
              {showCounters ? (
                <IonIcon icon={chevronDownOutline} />
              ) : (
                <IonIcon icon={chevronUpOutline} />
              )}
            </IonLabel>
          </IonItem>
          <IonItem
            lines="none"
            style={{ textAlign: "center", overflow: "visible" }}
            onClick={() => counterDropdownMobile()}
            className="item md item-lines-none ion-activatable ion-focusable hydrated item-label ion-activated ion-hide-md-up"
          >
            <IonLabel className="sc-IonLabel-md-h sc-IonLabel-md-s md">
              <IonIcon
                icon={warningOutline}
                style={{ color: "red", fontSize: 20, marginBottom: 3 }}
              />
              <IonText style={{ verticalAlign: "super", margin: 5 }}>{pending}</IonText>
            </IonLabel>
            <IonLabel className="sc-IonLabel-md-h sc-IonLabel-md-s md">
              <IonIcon
                icon={documentTextOutline}
                style={{ color: "red", fontSize: 20, marginBottom: 3 }}
              />
              <IonText style={{ verticalAlign: "super", margin: 5 }}>{pendingS}</IonText>
            </IonLabel>

            <IonLabel className="sc-IonLabel-md-h sc-IonLabel-md-s md">
              <IonIcon
                icon={timeOutline}
                color="warning"
                style={{ fontSize: 20, marginBottom: 3 }}
              />
              <IonText style={{ verticalAlign: "super", margin: 5 }}>{fexpire}</IonText>
            </IonLabel>

            <IonLabel className="sc-IonLabel-md-h sc-IonLabel-md-s md">
              <IonIcon icon={timeOutline} style={{ color: "red", fontSize: 20, marginBottom: 3 }} />
              <IonText style={{ verticalAlign: "super", margin: 5 }}>{expired}</IonText>
            </IonLabel>

            <IonLabel className="sc-IonLabel-md-h sc-IonLabel-md-s md">
              <IonIcon
                icon={receiptOutline}
                style={{ color: "red", fontSize: 20, marginBottom: 3 }}
              />
              <IonText style={{ verticalAlign: "super", margin: 5 }}>{complianceRejected}</IonText>
            </IonLabel>

            <IonLabel className="sc-IonLabel-md-h sc-IonLabel-md-s md">
              <IonIcon
                icon={receiptOutline}
                style={{ color: "blue", fontSize: 20, marginBottom: 3 }}
              />
              <IonText style={{ verticalAlign: "super", margin: 5 }}>{compliancePending}</IonText>
            </IonLabel>

            <IonLabel className="sc-IonLabel-md-h sc-IonLabel-md-s md">
              <IonIcon
                icon={checkmarkDoneOutline}
                color="success"
                style={{ fontSize: 20, marginBottom: 3 }}
              />
              <IonText style={{ verticalAlign: "super", margin: 5 }}>{ok}</IonText>
            </IonLabel>
            <IonLabel className="ion-hide-md-up">
              {showCounters ? (
                <IonIcon icon={chevronDownOutline} />
              ) : (
                <IonIcon icon={chevronUpOutline} />
              )}
            </IonLabel>
          </IonItem>
          {showCounters && (
            <IonList className="ion-hide-md-up">
              <IonItem>
                <IonLabel className="sc-IonLabel-md-h sc-IonLabel-md-s md">
                  <IonIcon
                    icon={warningOutline}
                    style={{ color: "red", fontSize: 20, marginBottom: 3 }}
                  />
                  <IonText style={{ verticalAlign: "super", margin: 5 }}>{pending}</IonText>
                  <h3>Pendientes</h3>
                </IonLabel>
              </IonItem>
              <IonItem>
                <IonLabel className="sc-IonLabel-md-h sc-IonLabel-md-s md">
                  <IonIcon
                    icon={documentTextOutline}
                    style={{ color: "red", fontSize: 20, marginBottom: 3 }}
                  />
                  <IonText style={{ verticalAlign: "super", margin: 5 }}>{pendingS}</IonText>
                  <h3>Firmas pendientes</h3>
                </IonLabel>
              </IonItem>
              <IonItem>
                <IonLabel className="sc-IonLabel-md-h sc-IonLabel-md-s md">
                  <IonIcon
                    icon={timeOutline}
                    color="warning"
                    style={{ fontSize: 20, marginBottom: 3 }}
                  />
                  <IonText style={{ verticalAlign: "super", margin: 5 }}>{fexpire}</IonText>
                  <h3>Por Vencer</h3>
                </IonLabel>
              </IonItem>
              <IonItem>
                <IonLabel className="sc-IonLabel-md-h sc-IonLabel-md-s md">
                  <IonIcon
                    icon={timeOutline}
                    style={{ color: "red", fontSize: 20, marginBottom: 3 }}
                  />
                  <IonText style={{ verticalAlign: "super", margin: 5 }}>{expired}</IonText>
                  <h3>Vencidos</h3>
                </IonLabel>
              </IonItem>
              <IonItem>
                <IonLabel className="sc-IonLabel-md-h sc-IonLabel-md-s md">
                  <IonIcon
                    icon={receiptOutline}
                    style={{ color: "red", fontSize: 20, marginBottom: 3 }}
                  />
                  <IonText style={{ verticalAlign: "super", margin: 5 }}>
                    {complianceRejected}
                  </IonText>
                  <h3>Pendientes Compliance</h3>
                </IonLabel>
              </IonItem>
              <IonItem>
                <IonLabel className="sc-IonLabel-md-h sc-IonLabel-md-s md">
                  <IonIcon
                    icon={receiptOutline}
                    style={{ color: "blue", fontSize: 20, marginBottom: 3 }}
                  />
                  <IonText style={{ verticalAlign: "super", margin: 5 }}>
                    {compliancePending}
                  </IonText>
                  <h3>Revisión Compliance</h3>
                </IonLabel>
              </IonItem>
              <IonItem>
                <IonLabel className="sc-IonLabel-md-h sc-IonLabel-md-s md">
                  <IonIcon
                    icon={checkmarkDoneOutline}
                    color="success"
                    style={{ fontSize: 20, marginBottom: 3 }}
                  />
                  <IonText style={{ verticalAlign: "super", margin: 5 }}>{ok}</IonText>
                  <h3>Ok</h3>
                </IonLabel>
              </IonItem>
            </IonList>
          )}
        </IonCard>

        <IonGrid>
          {status === "pending" && (
            <p className="ion-text-center">Cargando Carpeta de Documentos....</p>
          )}
          {status === "fulfilled" && userDocumentsList?.length === 0 && (
            <p className="ion-text-center">No se han encontrado Documentos</p>
          )}
          {userDocumentsList &&
            userDocumentsList?.map((categories, index) => (
              <IonCard className="md hydrated" key={index}>
                <IonItem
                  lines="full"
                  className="item md item-lines-none ion-activatable ion-focusable hydrated item-label ion-activated"
                  onClick={() => pasarIndex(index)}
                >
                  <IonLabel className="sc-IonLabel-md-h sc-IonLabel-md-s md">
                    <IonText color="primary" style={{ fontWeight: 500 }}>
                      {categories.name} ({`${categories.documents.length}`})
                    </IonText>
                  </IonLabel>
                  <IonLabel style={{ textAlign: "end", overflow: "visible" }}>
                    {okStatus[index] && categories.documents.length != 0 ? (
                      <>
                        <IonIcon
                          icon={checkmarkDoneOutline}
                          color="success"
                          style={{ fontSize: 20, marginBottom: 3 }}
                        />
                        <IonText style={{ verticalAlign: "super", margin: 5 }}>
                          {okStatus[index]}
                        </IonText>
                      </>
                    ) : null}
                    {signaturePending[index] != 0 && (
                      <>
                        <IonIcon
                          icon={documentTextOutline}
                          style={{ color: "red", fontSize: 20, marginBottom: 3 }}
                        />
                        <IonText style={{ verticalAlign: "super", margin: 5 }}>
                          {signaturePending[index]}
                        </IonText>
                      </>
                    )}
                    {nextToExpire[index] != 0 ? (
                      <>
                        <IonIcon
                          icon={timeOutline}
                          color="warning"
                          style={{ fontSize: 20, marginBottom: 3 }}
                        />
                        <IonText style={{ verticalAlign: "super", margin: 5 }}>
                          {nextToExpire[index]}
                        </IonText>
                      </>
                    ) : null}
                    {expiredDocuments[index] != 0 ? (
                      <>
                        <IonIcon
                          icon={timeOutline}
                          style={{ color: "red", fontSize: 20, marginBottom: 3 }}
                        />
                        <IonText style={{ verticalAlign: "super", margin: 5, marginRight: 10 }}>
                          {expiredDocuments[index]}
                        </IonText>
                      </>
                    ) : null}
                    {complianceRejectedStatus[index] != 0 && (
                      <>
                        <IonIcon
                          icon={receiptOutline}
                          style={{ color: "red", fontSize: 20, marginBottom: 3 }}
                        />
                        <IonText style={{ verticalAlign: "super", margin: 5 }}>
                          {complianceRejectedStatus[index]}
                        </IonText>
                      </>
                    )}
                    {compliancePendingStatus[index] != 0 && (
                      <>
                        <IonIcon
                          icon={receiptOutline}
                          style={{ color: "blue", fontSize: 20, marginBottom: 3 }}
                        />
                        <IonText style={{ verticalAlign: "super", margin: 5 }}>
                          {compliancePendingStatus[index]}
                        </IonText>
                      </>
                    )}
                    {categories.documents.length === 0 && (
                      <IonIcon
                        icon={warningOutline}
                        style={{ color: "red", fontSize: 20, marginBottom: 3 }}
                      />
                    )}
                    {lista[index] ? (
                      <IonIcon icon={chevronDownOutline} style={{ marginLeft: 40 }} />
                    ) : (
                      <IonIcon icon={chevronUpOutline} style={{ marginLeft: 40 }} />
                    )}
                  </IonLabel>
                </IonItem>
                {lista[index] && categories.documents.length != 0 && (
                  <UserDocumentsList
                    id_doc={categories.id}
                    userId={userId}
                    documentList={categories.documents}
                    expiration={categories.expirationDays}
                    key={index}
                  />
                )}
                {lista[index] && categories.documents.length === 0 && (
                  <IonRow>
                    <IonCol style={{ display: "flex", justifyContent: "center" }}>
                      <UploadButton
                        id_doc={categories.id}
                        userId={userId}
                        text={"Subir Documento"}
                      />
                    </IonCol>
                  </IonRow>
                )}
              </IonCard>
            ))}
        </IonGrid>
        <IonFab
          vertical="bottom"
          horizontal="end"
          slot="fixed"
          style={{ position: "fixed", bottom: 0 }}
        >
          <DocumentUploadTooltip userId={userId} />
        </IonFab>
      </section>
    </>
  );
};
